var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "font_style_group" },
    _vm._l(_vm.options, function (item) {
      return _c(
        "span",
        {
          key: item.value,
          class: [
            "style_item",
            "style_item_" + item.value,
            _vm.align === item.value ? "style_item_active" : "",
          ],
          on: {
            click: function ($event) {
              return _vm.on_click_align(item)
            },
          },
        },
        [_c("i", { staticClass: "iconfont icon", class: item.icon })]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }